var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8557 20H7.1443C6.47198 18.4348 5.16074 17.2206 3.52971 16.6767L3 16.5L3.52971 16.3233C5.32067 15.7261 6.72607 14.3207 7.32334 12.5297L7.5 12L7.67666 12.5297C8.27393 14.3207 9.67933 15.7261 11.4703 16.3233L12 16.5L11.4703 16.6767C9.83926 17.2206 8.52802 18.4348 7.8557 20ZM19.1667 7.85762V9.14238C17.6417 9.82499 16.461 11.1184 15.9267 12.7204L15.5 14L15.0733 12.7204C14.476 10.9294 13.0706 9.52402 11.2796 8.92675L10 8.5L11.2796 8.07325C13.0706 7.47598 14.476 6.07058 15.0733 4.27962L15.5 3L15.9267 4.27962C16.461 5.88155 17.6417 7.17501 19.1667 7.85762Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start-icon.8f3fb9a9692ae4975b9d3aec4d4d6e78.svg";
export { ForwardRef as ReactComponent };